import styled from 'styled-components'
import { Link as OrigLink } from 'gatsby'
import { media } from 'utils/styleUtils'
import { DOVE_GRAY, DARK_PAGAMO_RED } from 'constants/colors'

export const Container = styled.div`
  padding: 1.5rem 0;

  ${media.pad} {
    padding: 4rem 0;
  }
`

export const Sidebar = styled.aside`
  display: none;

  ${media.pad} {
    display: inline-block;
    width: 20%;
  }
`

export const Rows = styled.ul`
  li {
    list-style: none;
  }
`

export const Link = styled(props => <OrigLink {...props} />)`
  color: ${DOVE_GRAY};
  font-weight: 300;

  :hover {
    color: ${DARK_PAGAMO_RED};
  }
`

export const Content = styled.article`
  ${media.pad} {
    display: inline-block;
    vertical-align: top;
    width: 80%;
    padding-right: 20%;
  }
`

export const List = styled.div``

export const Title = styled.h2`
  text-align: center;
  font-weight: 500;

  ${media.pad} {
    text-align: left;
  }
`

export const QuestionWrapper = styled.div`
  margin-top: 1.5rem;
  font-weight: 300;

  ${media.pad} {
    margin-top: 3rem;
  }
`
